import {TaskIconCategory, TASK_ICON_CATEGORIES} from "./task-categories"

// Icon categories for AI agents — adds an "AI" group on top, then reuses
// the existing task icon set so agents can also pick general icons.
export const AI_AGENT_ICON_CATEGORIES: TaskIconCategory[] = [
    {
        name      : "AI",
        itemIcons : [
            'ai-default',
            'ai-brain',
            'ai-code',
            'ai-compass',
            'ai-gear',
            'ai-rocket',
            'ai-support',
            'ai-write',
        ],
    },
    ...TASK_ICON_CATEGORIES,
]
